import { HiLockClosed } from "react-icons/hi";
import { useWindowWidth } from "ui/utils/hooks";

interface IProps {
  onClick: () => void;
  Icon: React.ElementType;
  text: string;
  disabled?: boolean;
}

export function HomeButton({ onClick, Icon, text, disabled }: IProps) {
  const isDesktop = useWindowWidth();

  return (
    <div className="md:text-md flex w-full flex-col items-center justify-start text-center text-xs font-semibold">
      <button
        className="mb-2 flex h-[56px] w-[56px] items-center justify-center rounded-[12px] bg-white p-4 text-base font-bold md:mb-0 md:h-full md:w-full md:justify-between md:rounded-[20px] md:p-6"
        onClick={onClick}
      >
        <span className={`${disabled ? "opacity-30" : ""}`}>
          {isDesktop && text}
        </span>
        <span className={`h-6 w-6 ${disabled ? "opacity-30" : ""}`}>
          {disabled ? (
            <HiLockClosed size={24} color="#2B3674" />
          ) : (
            <Icon size={24} color="#2B3674" />
          )}
        </span>
      </button>
      <span className={`max-w-[80px] ${disabled ? "opacity-30" : ""}`}>
        {!isDesktop && text}
      </span>
    </div>
  );
}
